import { zSchema } from "@zeal/common";

export const postAiConversationRequestSchema = zSchema.object({
  companyId: zSchema.string().min(1),
  userId: zSchema.string().min(1),
  /** IANA timezone from the browser (e.g. Pacific/Honolulu). */
  clientTimeZone: zSchema.string().min(1).optional(),
  metadata: zSchema.record(zSchema.string(), zSchema.any()).optional(),
});

export type TPostAiConversationRequestSchema = zSchema.infer<
  typeof postAiConversationRequestSchema
>;

export const postAiConversationResponseSchema = zSchema.object({
  companyId: zSchema.string(),
  conversationId: zSchema.string(),
  sessionKey: zSchema.string(),
});

export type TPostAiConversationResponseSchema = zSchema.infer<
  typeof postAiConversationResponseSchema
>;
